<template>
  	<section class="copyrights">
    		<div class="container">
    			<div class="row">
    				<div class="col-md-12">
    					<p>Copyright© PMCH,All Right Reserved & Powered by <a class="color-white" href="https://www.nsmlimited.com/" target="_blank">NSM Limited</a></p>
    					<ul id="mr-hide" class="ulockd-footer-font-icon mt15">
    						<li class="list-inline-item"><a href="#"><i class="fab fa-facebook-f"></i></a></li>
    						<li class="list-inline-item"><a href="#"><i class="fas fa-rss"></i></a></li>
    						<li class="list-inline-item"><a href="#"><i class="fab fa-google"></i></a></li>
    						<li class="list-inline-item"><a href="#"><i class="fab fa-pinterest"></i></a></li>
    						<li class="list-inline-item"><a href="#"><i class="fab fa-instagram"></i></a></li>
    					</ul>
    				</div>
    			</div>
    		</div>
    	</section>
    	   <a class="scrollToHome" href="#"><i class="fa fa-home"></i></a>
    </template>